export const calculatePaperProps = ({
  paperHeight,
  paperWidth,
  printHeight,
  printWidth,
  landscape,
  useWidth
}) => {
  let width;
  let height;
  let borderH;
  let borderW;
  const ratio = (100 * paperHeight) / paperWidth;
  if (landscape) {
    width = '100%';
    height = `${ ratio }%`;
    const dH = (100 * ((paperHeight - printHeight) / 2)) / paperWidth;
    const dW = (100 * ((paperWidth - printWidth) / 2)) / paperWidth;
    borderH = dH;
    borderW = dW;
  } else {
    width = `${ ratio }%`;
    height = '100%';
    if (useWidth) {
      borderH = (100 * ((paperHeight - printHeight) / 2)) / paperWidth;
      borderW = (100 * ((paperWidth - printWidth) / 2)) / paperWidth;
    } else {
      borderH = (100 * ((paperHeight - printHeight) / 2)) / paperHeight;
      borderW = (100 * ((paperWidth - printWidth) / 2)) / paperHeight;
    }
  }
  return {
    width, height, borderH, borderW
  };
};

export const calculateFrameThickness = (width, frameThickness) => (
  (frameThickness / width) * 100
);
